import { event } from '@uhg-abyss/web/tools/event';
import { getAppPermissions } from '@src/common/NavMenuLink/permissionsFunctions';

/**
 * Handles permission checking and navigation logic for right rail links
 * @param {Object} params - Configuration object
 * @param {string} params.permission - Permission string to check
 * @param {Object} params.appDSPermissions - User's permissions object
 * @param {Function} params.toggleModal - Function to show permission modal
 * @param {string} params.name - Link display name
 * @param {Function} params.onClick - onClick callback function
 * @param {boolean} params.isDownload - Whether this is a download link
 * @param {string} params.href - Link href
 * @param {boolean} params.isSuperUser - Whether user is a super user
 * @param {boolean} params.isUhcInsightsUser - Whether user is UHC Insights user
 * @param {boolean} params.isInternal - Whether this is an internal link
 * @param {string} params.redirect - Processed redirect URL
 * @returns {void}
 */
export const checkPermissionAndHandle = ({
  permission,
  appDSPermissions,
  toggleModal,
  name,
  onClick,
  isDownload,
  href,
  isSuperUser,
  isUhcInsightsUser,
  isInternal,
  redirect,
}) => {
  let hasPermission = true;

  if (permission) {
    hasPermission = getAppPermissions(permission, appDSPermissions);
  }

  if (!hasPermission) {
    // Show permission modal instead of navigating
    toggleModal({ key: 'permissions', isOpen: true, toolName: name });
    return;
  }

  // If has permission, proceed with original onClick logic
  if (onClick) {
    onClick({ text: name, isDownload, link: href });
  }

  // Handle navigation based on user type and link type
  if (isSuperUser || isUhcInsightsUser) {
    if (!isInternal) {
      event('EXIT_LINK_NAVIGATE', {
        linkText: name,
        linkUrl: href,
      });
      window.open(
        `/api/identity/ohid/superusersso?redirect=${redirect}`,
        '_blank'
      );
    } else {
      event('NAVIGATION_CLICK', { name });
      window.location.replace(redirect);
    }
  } else {
    if (isInternal) {
      event('NAVIGATION_CLICK', { name });
      window.location.replace(redirect);
    } else {
      event('EXIT_LINK_NAVIGATE', {
        linkText: name,
        linkUrl: href,
      });
      window.open(redirect, '_blank');
    }
  }
};
